import styled from 'styled-components';

import {
  baseLighter,
  baseLighterDarkMode,
  baseMain,
  grayDark,
  grayMain,
  primaryLighter,
  primaryMain,
  redMain,
  white,
} from '@crehana/ui/dist/styles/colors';

export const StyledInput = styled.input<{
  darkMode?: boolean;
  hasError: boolean;
}>`
  ${({ darkMode, hasError }) => {
    const defaultBorderColor = darkMode ? baseLighterDarkMode : grayDark;
    const defaultFocusBorderColor = darkMode ? primaryLighter : primaryMain;

    return `
  &::-webkit-input-placeholder {
    color: ${darkMode ? baseLighter : grayDark};
  }
  &:-moz-placeholder { /* Firefox 18- */
    color: ${darkMode ? baseLighter : grayDark};
  }
  &::-moz-placeholder {  /* Firefox 19+ */
    color: ${darkMode ? baseLighter : grayDark};
  }
  &:-ms-input-placeholder {
    color: ${darkMode ? baseLighter : grayDark};
  }
  &::placeholder {
    color: ${darkMode ? baseLighter : grayDark};
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: ${darkMode ? white : baseMain} !important;
  }

  &:focus {
    border-color: ${hasError ? redMain : defaultFocusBorderColor}
  }

  &:disabled {
    background-color: ${grayMain};
    border: none;
  }

  border-color: ${hasError ? redMain : defaultBorderColor};
`;
  }}
`;
